/***
 *  MIT License
    Copyright (c) 2020 Mo Gorhom
    @see : https://github.com/gorhom/react-native-portal
 */

import { createContext } from 'react';

export const PortalStateContext = createContext(null);
export const PortalDispatchContext = createContext(null);